export default __webpack_public_path__ + "c9c93dec160d09cafffe22fd2d7006c9.svg";